import { X } from 'lucide-react';
import { cn } from '@/lib/utils';

const StepperHeader = ({ steps, currentIndex, title, subtitle, onClose }) => {
  const stepNum = currentIndex + 1;
  const totalSteps = steps.length;

  return (
    <div className="w-full mb-6">
      <div className="flex items-center justify-between mb-4">
        <span className="text-xs font-medium text-gray-400 uppercase tracking-widest">
          STEP {stepNum}-{totalSteps}
        </span>
        <div className="flex items-center gap-1.5">
          {steps.map((_, i) => (
            <span
              key={i}
              className={cn(
                'block w-2.5 h-2.5 rounded-full transition-colors duration-300',
                i < currentIndex && 'bg-green-500',
                i === currentIndex && 'bg-[#FEBA08]',
                i > currentIndex && 'bg-[#2a2a2a] border border-gray-600'
              )}
            />
          ))}
        </div>
        <button
          onClick={onClose}
          className="text-gray-500 hover:text-gray-300 transition-colors"
          aria-label="Close"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
      <div className="text-center">
        <h2 className="text-2xl font-semibold text-white">{title}</h2>
        {subtitle && <p className="mt-2 text-sm text-gray-400 max-w-xs mx-auto">{subtitle}</p>}
      </div>
    </div>
  );
};

export default StepperHeader;
